import './i18n';
import 'ress';
import 'chota';
import './app.css'
import App from './App.svelte'
import './modernizr-custom.js'
import { mount } from 'svelte'
import { installVersionGuard } from './lib/versionGuard.js'

// Installed before mounting so a stale bundle reloads itself as early as possible.
installVersionGuard()

// #app is an empty container in index.html; the static crawler markup lives in a
// separate #seo-static sibling, so there is nothing here to tear down before mounting.
const target = document.getElementById('app') || document.body;

const app = mount(App, {
  target: target
})

// The static block has done its job once the app is live. It is already hidden before
// first paint by the <head> gate, but drop it from the DOM too: left in place it gives the
// document a second <main>/<header>/<h1>, which breaks any `main` selector (Playwright
// strict mode resolves two elements) and leaves duplicate landmarks for screen readers.
document.getElementById('seo-static')?.remove();

export default app
